/****************************************************************
 * CODE quickshopWrapper
 ****************************************************************/

let quickshopWrapper = {};

quickshopWrapper.config = {
  section_id: 'main-product-quick-shop-panel',
  quickShopPanel: document.querySelector('quick-shop-panel'),
};

// Catch clicks on body
document.body.addEventListener(
  'click',
  function (event) {
    const element = event.target.closest('[data-product-handle]');

    // Only handle clicks on quick shop buttons
    if (!element || event.target.type !== 'button') {
      return;
    }

    event.stopPropagation();

    // Store button
    quickshopWrapper.toggleButton = event.target;

    // Get handle
    quickshopWrapper.handle = element.dataset.productHandle;

    quickshopWrapper.productId = element.dataset.productId;

    fetchAndLoadProductVariants(event);
  },
  false
);

/**
 * fetchAndLoadProductVariants
 * @param {Object} event
 */
async function fetchAndLoadProductVariants(event) {
  quickshopWrapper.config.quickShopPanel.disableQuickshopButton();

  // Set loading state on quick shop
  quickshopWrapper.config.quickShopPanel.quickshopPanelLoading();

  try {
    // Get product variants
    const response = await fetch(`/products/${quickshopWrapper.handle}?section_id=${quickshopWrapper.config.section_id}`);
    const result = await response.text();
    // Set fetched content to the panel
    const target = document.querySelector('[data-quick-shop-panel="content"]');
    const html = new DOMParser().parseFromString(result, 'text/html').querySelector('.shopify-section').innerHTML;
    target.innerHTML = html;

    // Find all variant items
    const items = target.querySelectorAll('[data-variant="input"]');

    // If there is only one variant, add it to the cart
    if (items.length === 1) {
      items[0].closest('div').querySelector('[data-variant="add-to-cart"]').click();
    } else {
      // else open the variant drawer
      quickshopWrapper.config.quickShopPanel.quickshopPanelLoading(false);
      quickshopWrapper.config.quickShopPanel.open();
    }
  } catch (error) {
    console.log(error);
    quickshopWrapper.config.quickShopPanel.close();
    quickshopWrapper.config.quickShopPanel.disableQuickshopButton(false);
    quickshopWrapper.config.quickShopPanel.quickshopButtonLoading(false);
  }
}

// Quick shop panel
if (!customElements.get('quick-shop-panel')) {
  class QuickShopPanel extends HTMLElement {
    constructor() {
      super();
      this.backdrop = this.querySelector('[data-quick-shop-panel="backdrop"]');
      this.offcanvas = this.querySelector('[data-quick-shop-panel="offcanvas"]');
      this.content = this.querySelector('[data-quick-shop-panel="content"]');

      // Close and remove the panel when clicked on the backdrop
      this.backdrop.addEventListener('click', () => {
        quickshopWrapper.config.quickShopPanel.disableQuickshopButton(false);
        this.close();
      });
    }
    /**
     * open Panel
     * @description Open content panel.
     */
    open() {
      document.body.classList.add('quick-shop-panel-open');
    }

    /**
     * close Panel
     * @description Close and empty content panel.
     */
    close() {
      document.body.classList.remove('quick-shop-panel-open');
      this.content.textContent = '';
    }

    /**
     * disableQuickshopButton
     * @description dis/enable the quickshop button based on state
     * @param state {Boolean}
     */
    disableQuickshopButton(state = true) {
      if (!quickshopWrapper.toggleButton) return;
      quickshopWrapper.toggleButton.disabled = state;
    }

    /**
     * quickshopButtonLoading
     * @description Show loader in the clicked quickshop button based on state
     * @param state {Boolean}
     */
    quickshopButtonLoading(state = true) {
      if (!quickshopWrapper.toggleButton) return;
      const loader = quickshopWrapper.toggleButton.querySelector('[data-quickshop-loader]');
      const cartIcon = quickshopWrapper.toggleButton.querySelector('[data-quickshop-icon]');
      if (!loader) return;
      if (state) {
        cartIcon.classList.add('hidden');
        loader.classList.remove('hidden');
      } else {
        cartIcon.classList.remove('hidden');
        loader.classList.add('hidden');
      }
    }

    /**
     * quickshopPanelLoading
     * @description show loader in quickshop panel based on state
     * @param state {Boolean}
     */
    quickshopPanelLoading(state = true) {
      state ? this.classList.add('loading') : this.classList.remove('loading');
    }
  }
  window.QuickShopPanel = QuickShopPanel;
  customElements.define('quick-shop-panel', QuickShopPanel);
}

// Quick shop selector
if (!customElements.get('quick-shop-selector')) {
  class QuickShopSelector extends HTMLElement {
    constructor() {
      super();
      this.quickShopPanel = document.querySelector('quick-shop-panel');

      this.variantItems = this.querySelectorAll('[data-variant="item"]');
      this.variantItems.forEach((variantItem) => {
        variantItem.addEventListener('click', (event) => {
          this.handleVariantSelect(event);
        });
      });

      this.closeButtons = this.quickShopPanel.querySelectorAll('[data-quick-shop-panel="close"]');
      this.closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          quickshopWrapper.config.quickShopPanel.disableQuickshopButton(false);
          this.quickShopPanel.close();
        });
      });
    }

    async handleVariantSelect(event) {
      const variantItem = event.currentTarget;

      variantItem.classList.add('pointer-events-none');
      await this.onOptionSelect(variantItem);
      variantItem.classList.remove('pointer-events-none');
      this.quickShopPanel.close();

      document.dispatchEvent(
        new CustomEvent('quickshop-close', {
          bubbles: true,
        })
      );
    }

    /**
     * onOptionSelect
     * @description Updates properties and submits the form
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    async onOptionSelect(variantItem) {
      const input = variantItem.querySelector('input[name="id"]');
      const variantId = input.value;
      const productForm = this.querySelector('product-form');
      const submitButton = productForm.querySelector('[type="submit"]');

      const updateProperties = JSON.parse(variantItem.dataset.updateProperties);
      updateProperties['id'] = variantId;

      // Update all line_item properties
      Object.entries(updateProperties).forEach(([k, v]) => {
        productForm.querySelector(`input[name="${k}"]`).value = v;
      });

      submitButton.click();
    }
  }
  window.QuickShopSelector = QuickShopSelector;
  customElements.define('quick-shop-selector', QuickShopSelector);
}
